import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function PictureAsPdfIcon(props: FixMe) {
  return <PictureAsPdf {...props} />;
}

export default PictureAsPdfIcon;
